import { observer } from "mobx-react";
import { Button, useKeyEvent } from "monday-ui-react-core";
import { useCallback, useState } from "react";
import useCalculateInvestmentSummary from "../../../hooks/useCalculateInvestmentSummary";
import { useStore } from "../../../store";
import Classes from "./CalculateButton.module.scss";

const CalculateButton = () => {
  const { context } = useStore();
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const calculateInvestmentSummary = useCalculateInvestmentSummary();

  const onClick = useCallback(() => {
    if (
      context.principal === 0 &&
      context.monthlyDeposit === 0 &&
      context.numberOfYears === 0 &&
      context.annualInterestRate === 0
    ) {
      setShowErrorMessage(true);
      setTimeout(() => setShowErrorMessage(false), 3000);
      return;
    }
    window?.top?.postMessage('calculate-button-clicked', '*');
    calculateInvestmentSummary();
  }, [calculateInvestmentSummary, context]);
  useKeyEvent({
    keys: ["Enter"],
    callback: onClick,
    stopPropagation: true,
  });

  return (
    <>
      {showErrorMessage && (
        <div className={Classes.errorMessage}>אנא הזינו נתונים</div>
      )}
      <Button onClick={onClick} className={Classes.button}>
        חשב
      </Button>
    </>
  );
};

export default observer(CalculateButton);
